import React, { useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";

const EmpyDrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  //...theme.mixins.toolbar,
  minHeight: 48,
}));
const DrawerHeader = ({ children }) => {
  return <EmpyDrawerHeader>{children}</EmpyDrawerHeader>;
};

export default DrawerHeader;
